import React from "react";
import { ErrorIcon } from "./ErrorIcon";
import "./style.scss";

interface FormItemProps {
  label?: string;
  fieldId: string;
  mandatory?: boolean;
  errorText?: string;
  iconRight?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
}

export const FormItem: React.FC<FormItemProps> = ({
  label,
  fieldId,
  mandatory = false,
  errorText,
  iconRight,
  className,
  children
}) => (
  <div className={`form-item ${className ?? ""}`}>
    <label htmlFor={fieldId} className="form-item__field__label">
      {mandatory && <span className="form-item__field__mandatory">*</span>}
      {label}
      {iconRight}
    </label>
    <div className="form-item__field__input">{children}</div>
    {
      errorText ?
        <div className="form-item__field__error"><ErrorIcon/>{errorText}</div>
        : <div style={{ visibility: "hidden" }} className="form-item__field__error"></div>
    }
  </div>
);
